const env = {
  // localhost
  development: {
    urls: {
      hyperpureHost: "https://devapi.hyperpure.com",
      mapKey: "AIzaSyD7seh5YCNnDsFOpI69C6CFJ4aJX04MC6E"
    },
  },
  production: {
    urls: {
      hyperpureHost: "https://api.hyperpure.com",
      mapKey: "AIzaSyD8cwg23urRNJ2Pi0ERs5UDbZFhbjV9ZcU"
    },
  },
  staging: {
    urls: {
      hyperpureHost: "https://api.hyperpure.com",
      mapKey: "AIzaSyD8cwg23urRNJ2Pi0ERs5UDbZFhbjV9ZcU"
    },
  },
  // development
  devServer: {
    urls: {
      hyperpureHost: "https://devapi.hyperpure.com",
      mapKey: "AIzaSyD8cwg23urRNJ2Pi0ERs5UDbZFhbjV9ZcU"
    },
  },
};

let envEndpoints = "";
if (process.env.REACT_APP_API_ENDPOINT) {
  envEndpoints = env[process.env.REACT_APP_API_ENDPOINT];
} else {
  envEndpoints = env[process.env.NODE_ENV];
}

export default envEndpoints;
